import React, { useEffect, useState } from "react";
import "./Page3Row1.css";
import CartPro1 from "../Page3Row1/Page3Row1Images/CartPro1.jpg";
import CartPro2 from "../Page3Row1/Page3Row1Images/CartPro2.jpg";
import GarbageIcon from "./GarbageIcon";
import OrderIcon from "../../All Icons and Logos/OrderIcon";
import JustOrderIcon from "../../GridRow2ndPage/JustOrderIcon";
import GreenBoxOrderIcon from "./GreenBoxOrderIcon";
import GridRow15 from "../../GridRows(13-15)/GridRow15";

export default function Page3Row1() {
  useEffect(() => {
    const cartProduct = ["hiiiiii", "Ma", " ", "Äaaaaa", "Matsddfr", " "];
    const cartProduct1 = [
      {
        name: " ",
        product: " ",
      },
    ];

    const cartProduct2 = cartProduct1.map((item) => {
      cartProduct.forEach((arr, index) => {
        if (cartProduct[index] != " " && cartProduct[index + 1] != " ") {
          item.key = Date.now();
          item.name = cartProduct[index];
          item.product = cartProduct[index + 1];

          console.log(item);
        }
      });
    });
    console.log(cartProduct1);
  }, []);

  const [Quantity, setQuantity] = useState("1");

  const cartProducts = [
    {
      CartProductImage: CartPro1,
      CartProductName: "ÄNGSKORN",
      CartProductUsage: "Mattress protector",
      CartProductColor: null,
      CartProductDimensions: "180x200 cm (71x79')",
      CartProductNumber: "004.619.92",

      cartQuantity: 1,
      CartProductPrice: 1790.0,
    },
    {
      CartProductImage: CartPro2,
      CartProductName: "SONGESAND",
      CartProductUsage: "Chest of 3 drawers",
      CartProductColor: "white",
      CartProductDimensions: "82x81 cm (32 1/4x31 7/8 ')",
      CartProductNumber: "703.667.60",
      cartQuantity: 1,
      CartProductPrice: 9990.0,
    },
  ];

  // console.log(
  //   cartProducts[0].CartProductPrice * cartProducts[0].CartProductQuantity
  // );
  console.log(cartProducts[0].CartProductPrice * Quantity);
  for (var i = 0; i < cartProducts.length; i++) {
    cartProducts.CartProductPrice = cartProducts.CartProductPrice * Quantity[i];

    // cartProducts.CartProductPrice = cartProducts.CartProductPrice * Quantity;
    var total = cartProducts.reduce((item, curr) => {
      return (
        parseInt(item.CartProductPrice * Quantity) +
        parseInt(curr.CartProductPrice * Quantity)
      );
    });
    //   var total = 0;
    //   total = total + parseInt(cartProducts[i].CartProductPrice * Quantity);
    //
  }

  cartProducts.CartProductPrice = cartProducts.CartProductPrice.toLocaleString(
    "en-IN",
    {
      style: "currency",
      currency: "INR",
    }
  );

  console.log(typeof Quantity);
  return (
    <>
      <div className="FullPage3">
        <div className="CartProductValuesHeading">
          <h1>Shopping Cart</h1>
        </div>
        <div className="Page3Row1">
          <div className="CartProductValues">
            {/* {cartProducts.forEach((item, index) => { */}
            {cartProducts.map((item, index) => {
              const QuantityHandler = (event) => {
                setQuantity(event.target.value);
              };
              return (
                <>
                  {" "}
                  <div className="CartProductValuesTitle">
                    <div className="CartProductValuesTitle11">
                      <div
                        key={item.CartProductName}
                        className="CartProductImages"
                      >
                        <img src={item.CartProductImage} />
                      </div>
                      <div className="CartProductValues1">
                        {" "}
                        <p>{item.CartProductName}</p>
                        <p>{item.CartProductUsage}</p>
                        <p>{item.CartProductColor}</p>
                        <p>{item.CartProductDimensions}</p>
                        <p>{item.CartProductNumber}</p>
                      </div>
                    </div>
                    <div className="CartProductValues2">
                      <p key={item.CartProductName}>
                        {(item.CartProductPrice * Quantity).toLocaleString(
                          "en-IN",
                          {
                            style: "currency",
                            currency: "INR",
                          }
                        )}
                      </p>
                      <div className="selectAndTrashIcon">
                        <GarbageIcon />
                        <select onChange={QuantityHandler}>
                          <option value="1">1</option>
                          <option value="2">2</option>
                          <option value="3">3</option>
                          <option value="4">4</option>
                          <option value="5">5</option>
                          <option value="6">6</option>
                          <option value="7">7</option>
                          <option value="8">8</option>
                          <option value="9">9</option>
                          <option value="10">10</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </>
              );
              // });
            })}
          </div>
        </div>
        <div className="SubTotalContainer">
          <h4>Sub Total</h4>
          <h4>
            {total.toLocaleString("en-IN", {
              style: "currency",
              currency: "INR",
            })}
          </h4>
        </div>

        <div className="GreenBox">
          <p>
            <div>
              <GreenBoxOrderIcon />
            </div>
            Delivery details will be calculated in the next page, please enter
            the pincode below to continue
          </p>
        </div>
        <div className="OptionsToOrder">
          <h2>How would you like to receive your order?</h2>
        </div>
        <div className="OptionsToOrderContent">
          <div className="OptionsToOrderContent1">
            <img
              src="https://order.ikea.com/in/en/checkout/static/media/ws-home-delivery.518b39d7.svg"
              className="orderIconPage31"
            ></img>
            <p>Home Delivery</p>
          </div>
          <div className="OptionsToOrderContent2">
            <img
              src="https://order.ikea.com/in/en/checkout/static/media/ws-click-and-collect.6cad58e4.svg"
              className="orderIconPage31"
            ></img>
            <p>Click & Collect</p>
          </div>
        </div>
        <div className="ServicesAndPolicy">
          <div className="ServicesAndPolicyContent1">
            <div className="ServicesAndPolicyContent11">
              <img
                src="https://www.ikea.com/images/delivery-2c377c3cc69640f749013836110d40ad.jpg"
                className="orderIconPage3"
              ></img>
            </div>
            <div className="ServicesAndPolicyContent12">
              <p>Our Delivery Service</p>
              <p>
                Safe & contact-less delivery according to government permission.
              </p>
              <a>More info</a>
            </div>
          </div>
          <div className="ServicesAndPolicyContent1">
            <div className="ServicesAndPolicyContent11">
              <img
                src="https://www.ikea.com/images/delivery-014ad6216fa3d6d633f4be02a031b03b.jpg"
                className="orderIconPage3"
              ></img>
            </div>
            <div className="ServicesAndPolicyContent12">
              <p>Our Return Policy</p>
              <p>
                We have made some updates to our return policy due to the COVID
                19 situation.
              </p>
              <a>More info</a>
            </div>
          </div>{" "}
          <div className="ServicesAndPolicyContent1">
            <div className="ServicesAndPolicyContent11">
              <img
                src="https://www.ikea.com/images/service-be6f35e18f0f32db81888e1f8c2bc401.jpg"
                className="orderIconPage3"
              ></img>
            </div>
            <div className="ServicesAndPolicyContent12">
              <p>Our Assembly Service</p>
              <p>
                Sometimes it is nice to have someone else assemble it for you.
              </p>
              <a>More info</a>
            </div>
          </div>
        </div>
        <div id="ForGrid15Id" className="ForGrid15">
          <GridRow15 />
        </div>
      </div>
    </>
  );
}
